import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  switch(event) {
    const index = event.currentTarget.dataset.index

    this.tabTargets.forEach((tab, i) => {
      if (i == index) {
        tab.classList.add("border-primary")
        tab.classList.remove("border-transparent")
      } else {
        tab.classList.remove("border-primary")
        tab.classList.add("border-transparent")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i != index)
    })
  }
}